<header class="header">
  <div class="header-bg">
  </div>
  <div class="container header-content">
    <div class="logo">
      <img (click)="redirect()" tabindex="0" (keydown.enter)="redirect()" src="assets/images/footer-logo.svg" alt="Delta Dental">
    </div>

    <button type="button" class="hamburger-btn" aria-label="Toggle navigation menu" (click)="toggleMenu()" [class.active]="isMenuOpen">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav class="nav-menu" [class.open]="isMenuOpen">
      <button type="button" class="nav-link ResourceLink" (click)="downloadResourcePdf()">Resources</button>
      <div class="user-profile" (click)="toggleProfileMenu()">
        <div class="user-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span class="username">Hello, {{userName}}!</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
        <div class="dropdown-menu" *ngIf="isProfileMenuOpen">
          @if(!impersonatedUser && !isAdminPage){
            <div class="items">
              <img src="assets/images/edit-profile.svg" class="editprofile-icon" alt="edit-profile-img">
              <a class="dropdown-item" (click)="editProfile()">Edit profile</a>
            </div>
          }
          <div class="items">
            <mat-icon class="logout-button" aria-label="logout">logout</mat-icon>
            <a class="dropdown-item" (click)="logOut()">Logout</a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>